import { useAppContext } from "../AppProviders";

function Home() {
  const { permissions, user, roles } = useAppContext();

  return (
    <>
      <div>{user && <pre>{JSON.stringify(user, null, 4)}</pre>}</div>
      <div>{JSON.stringify(permissions)}</div>
      <div>{JSON.stringify(roles)}</div>
    </>
  );
}

export default Home;
